import type { ColumnConfig } from "../types";
import { bulkSelectColumn } from "./bulkSelect/DiscoverGamesBulkSelectCell";
import * as analysis from "./columnGroups/analysisColumns";
import * as basic from "./columnGroups/basicColumns";
import * as manager from "./columnGroups/managerColumns";
import * as statusMedia from "./columnGroups/statusMediaColumns";
import * as team from "./columnGroups/teamColumns";
import { buildReadOnlyTooltips } from "./rowHelpers";
import type { DiscoverGamesColumnsParams, GameRow } from "./types";

/**
 * Column definitions for DiscoverGames table.
 * **Call from a React `useMemo` (not at module load)** so `_("...")` runs after `translator.add()`
 * in `admin` `main.tsx`.
 * Matches the legacy DiscoverGamesTable.tsx format and ORDER.
 */
export function getDiscoverGamesColumns(params: DiscoverGamesColumnsParams = {}): ColumnConfig<GameRow>[] {
	const p: DiscoverGamesColumnsParams = {
		clubManagerOptions: params.clubManagerOptions ?? [],
		contentManagerOptions: params.contentManagerOptions ?? [],
		assigneeOptions: params.assigneeOptions ?? [],
		gameStatusOptions: params.gameStatusOptions ?? [],
		onClubManagerChange: params.onClubManagerChange,
		onContentManagerChange: params.onContentManagerChange,
		onAssigneeChange: params.onAssigneeChange,
		onPriorityChange: params.onPriorityChange,
		onGameStatusChange: params.onGameStatusChange,
		onIsVipChange: params.onIsVipChange,
		onGameAnalysisOpen: params.onGameAnalysisOpen,
		isClubMetadataUpdating: params.isClubMetadataUpdating ?? false,
		canEditGameUploads: params.canEditGameUploads ?? false,
		canEditAssignee: params.canEditAssignee ?? false,
		canEditGameStatus: params.canEditGameStatus ?? false,
		canEditPriority: params.canEditPriority ?? false,
		canEditVip: params.canEditVip ?? false,
		canViewSla: params.canViewSla ?? false,
		tooltips: buildReadOnlyTooltips(params),
	};

	return [
		bulkSelectColumn(),
		basic.idColumn(),
		basic.dateColumn(),
		basic.createdAtColumn(),
		basic.countryColumn(),
		team.homeColumn(),
		team.awayColumn(),
		basic.ageCategoryColumn(),
		basic.scoreColumn(),
		manager.clubManagerColumn(p),
		manager.contentManagerColumn(p),
		manager.assigneeColumn(p),
		basic.teamSheetColumn(),
		statusMedia.hasVideoColumn(),
		analysis.providerTagColumn(p),
		analysis.gameAnalysisStatusColumn(),
		analysis.priorityColumn(p),
		analysis.gameStatusColumn(p),
		analysis.gameHistoriesCountColumn(),
		analysis.analysisTurnaroundColumn(),
		analysis.analysisSlaColumn(),
		analysis.physicalMetricsRequestedColumn(),
		statusMedia.isVipColumn(p),
		statusMedia.isHiddenColumn(),
		statusMedia.isHiddenForScoutColumn(),
		statusMedia.ownersColumn(),
		statusMedia.isDiscoverColumn(),
		statusMedia.requestedProcessingLevelColumn(),
		...(p.canViewSla ? [analysis.slaContentColumn(), analysis.slaExpansionColumn()] : []),
		analysis.numberOfContentErrorsColumn(),
		analysis.numberOfTaggingErrorsColumn(),
		analysis.analysisRequestedAtColumn(),
	];
}
